import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { LoginCentered } from 'navigation/login';
import Dialog from '@material-ui/core/Dialog';
import { localize } from 'react-localize-redux';

const styling = theme => ({
  paper: {
    width: '347px',
  },
});

class LoginDialog extends Component {
  render() {
    return (
      <Dialog
        disableBackdropClick
        open={this.props.isOpen}
        onClose={this.props.handleClose}
        aria-labelledby="login-help"
        style={{ padding: 0 }}
        maxWidth="xs"
        classes={{ paperWidthXs: this.props.classes.paper }}
      >
        <DialogTitle id="add-new-journal-entry">
          <h4 style={{ margin: 0 }}>{this.props.translate('forYourSecurity')}</h4>
        </DialogTitle>
        <DialogContent style={{ padding: 0, marginTop: '-20px' }}>
          <LoginCentered />
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styling)(localize()(LoginDialog));
